import React, { useEffect, useRef, useState } from "react";
import styles from "./Button.module.scss";
import classNames from "classnames";

// Handler yang langsung selesai (misal formik.handleSubmit) tetap dikunci sesaat,
// supaya klik cepat berturut-turut tidak menjalankan aksi dua kali.
export const CLICK_LOCK_MS = 400;

const Button = ({
  type,
  variant,
  size,
  children,
  onClick,
  isDisabled,
  disabled,
  ...props
}) => {
  const buttonClasses = classNames(
    styles.button,
    styles[variant],
    styles[size]
  );

  const [isSubmitting, setSubmitting] = useState(false);
  const submittingRef = useRef(false);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const handleClick = (event) => {
    if (submittingRef.current) {
      // klik yang dikunci tetap harus membatalkan submit bawaan <button type="submit">
      event.preventDefault();
      return;
    }
    submittingRef.current = true;

    let result;
    try {
      result = onClick?.(event);
    } catch (error) {
      submittingRef.current = false;
      throw error;
    }

    const isPending = result && typeof result.then === "function";
    if (isPending) setSubmitting(true);

    let remaining = isPending ? 2 : 1;
    const release = () => {
      remaining -= 1;
      if (remaining > 0) return;
      submittingRef.current = false;
      if (mountedRef.current) setSubmitting(false);
    };

    setTimeout(release, CLICK_LOCK_MS);
    if (isPending) result.then(release, release);
  };

  return (
    <button
      type={type}
      className={buttonClasses}
      onClick={handleClick}
      {...props}
      disabled={isDisabled || disabled || isSubmitting}
      aria-busy={isSubmitting || undefined}
    >
      {children}
    </button>
  );
};

export default Button;
